module.exports = __webpack_public_path__ + "static/media/BackgroundDetailDesktop.37c89f4c.jpg";